import { ProgramTemplateTranslationDto } from "../../dto/programs/program-template-translations.dto"
import { ProgramTemplateTranslation } from "../../models/programs/program-template.model"

export class ProgramTemplateTranslationMapper {
  public static toModel(dto: ProgramTemplateTranslationDto): ProgramTemplateTranslation {
    return {
      languageId: dto.language_id,
      title: dto.title,
      description: dto.description
    }
  }

  public static toDto(dto: ProgramTemplateTranslation): ProgramTemplateTranslationDto {
    return {
      language_id: dto.languageId,
      title: dto.title,
      description: dto.description
    }
  }
}